var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 150.37 228.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient);\n        opacity: .8;\n      }\n\n      .cls-3 {\n        fill: rgba(24, 37, 45, .2);\n        opacity: .5;\n      }\n\n      .cls-4 {\n        fill: #f7fcfd;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 75.18,
    y1: -5,
    x2: 75.18,
    y2: 324.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b65f93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#9b62c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8e64da"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 27.4,
    y1: 79.8,
    x2: 122.97,
    y2: 79.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7fcfd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m0,208.48V0h150.37v208.48c0,11.23-9.11,20.34-20.34,20.34H20.34c-11.23,0-20.34-9.11-20.34-20.34Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m77.59,67.29h-7.21v28.83l22.83,13.7,3.6-5.91-19.22-11.39v-25.23Zm23.24-29.75l22.14,18.48-6.15,7.38-22.15-18.47,6.17-7.39Zm-51.29,0l6.16,7.38-22.14,18.47-6.15-7.38,22.13-18.47Zm25.65,10.52c-23.88,0-43.25,19.37-43.25,43.25s19.37,43.25,43.25,43.25,43.25-19.37,43.25-43.25-19.37-43.25-43.25-43.25Zm0,76.89c-18.55,0-33.64-15.09-33.64-33.64s15.09-33.64,33.64-33.64,33.64,15.09,33.64,33.64-15.09,33.64-33.64,33.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m77.58,61.04h-7.21v28.83l22.83,13.7,3.6-5.91-19.22-11.39v-25.23Zm23.24-29.75l22.14,18.48-6.15,7.38-22.15-18.47,6.17-7.39Zm-51.29,0l6.16,7.38-22.14,18.47-6.15-7.38,22.13-18.47Zm25.65,10.52c-23.88,0-43.25,19.37-43.25,43.25s19.37,43.25,43.25,43.25,43.25-19.37,43.25-43.25-19.37-43.25-43.25-43.25Zm0,76.89c-18.55,0-33.64-15.09-33.64-33.64s15.09-33.64,33.64-33.64,33.64,15.09,33.64,33.64-15.09,33.64-33.64,33.64Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m20.94,195.99v-33.82c0-.54.27-.81.81-.81h4.05c.47,0,.81.19,1.01.56l14.18,23.19c.07.14.14.18.23.15.09-.03.13-.12.13-.25v-22.84c0-.54.27-.81.81-.81h4.25c.54,0,.81.27.81.81v33.82c0,.54-.27.81-.81.81h-4.15c-.47,0-.81-.18-1.01-.56l-14.18-23.34c-.07-.14-.14-.19-.23-.15-.08.03-.13.12-.13.25l.05,22.99c0,.54-.27.81-.81.81h-4.2c-.54,0-.81-.27-.81-.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m80.83,166.42h-17.01c-.2,0-.3.1-.3.3v9.37c0,.2.1.3.3.3h11.34c.54,0,.81.27.81.81v3.44c0,.54-.27.81-.81.81h-11.34c-.2,0-.3.1-.3.3v9.67c0,.2.1.3.3.3h17.01c.54,0,.81.27.81.81v3.44c0,.54-.27.81-.81.81h-22.38c-.54,0-.81-.27-.81-.81v-33.82c0-.54.27-.81.81-.81h22.38c.54,0,.81.27.81.81v3.44c0,.54-.27.81-.81.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m98.12,196.09l-9.12-33.82c-.03-.07-.05-.15-.05-.25,0-.2.07-.36.2-.48s.32-.18.56-.18h4.56c.47,0,.76.24.86.71l5.72,22.79c.04.14.1.2.2.2s.17-.07.2-.2l5.42-22.79c.1-.47.39-.71.86-.71h4.56c.51,0,.81.24.91.71l5.77,22.79c.03.14.1.2.2.2s.17-.07.2-.2l5.62-22.79c.1-.47.39-.71.86-.71h4.36c.27,0,.46.09.58.25.12.17.14.39.08.66l-8.61,33.82c-.1.47-.41.71-.91.71h-4.4c-.47,0-.76-.24-.86-.71l-5.87-23.85c-.03-.14-.1-.2-.2-.2s-.17.07-.2.2l-5.62,23.85c-.1.47-.39.71-.86.71h-4.1c-.51,0-.81-.24-.91-.71Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewIcon);
export default __webpack_public_path__ + "static/media/newIcon.48040c7d4f57dd49f89a269eb764a287.svg";
export { ForwardRef as ReactComponent };